// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2ZAhv","image":"Header_image__9uPi5","name":"Header_name__1otcT","info":"Header_info__3I6xI","infoRow":"Header_infoRow__FS-b3"};